import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7396862e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-sm" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "well well-sm" }
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = { style: {"display":"flex","align-items":"center","paddingLeft":"15px","paddingRight":"15px","paddingTop":"15px"} }
const _hoisted_6 = { style: {"width":"70%","display":"flex","flex-direction":"row"} }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { style: {"min-width":"90px","min-height":"90px","paddingRight":"5px"} }
const _hoisted_9 = ["src"]
const _hoisted_10 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text__title--semismall_bold__black",
  style: {"paddingTop":"10px"}
}, "PROIECT:", -1))
const _hoisted_12 = {
  class: "text__title--semismall_bold__black",
  style: {"paddingTop":"10px","paddingLeft":"5px"}
}
const _hoisted_13 = { class: "text__title--small_normal__black" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--small_normal" }, "Start:", -1))
const _hoisted_15 = {
  class: "text__title--small_bold__black",
  style: {"paddingLeft":"5px"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text__title--small_normal",
  style: {"paddingLeft":"15px"}
}, "End:", -1))
const _hoisted_17 = {
  class: "text__title--small_bold__black",
  style: {"paddingLeft":"5px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text__title--small_normal",
  style: {"paddingLeft":"15px"}
}, "Total zile:", -1))
const _hoisted_19 = {
  class: "text__title--small_bold__black",
  style: {"paddingLeft":"5px"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--small_normal" }, "Creat de:", -1))
const _hoisted_21 = {
  class: "text__title--small_bold__black",
  style: {"paddingLeft":"5px"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text__title--small_normal",
  style: {"paddingLeft":"15px"}
}, "Manager Proiect:", -1))
const _hoisted_23 = {
  class: "text__title--small_bold__black",
  style: {"paddingLeft":"5px"}
}
const _hoisted_24 = { class: "row" }
const _hoisted_25 = {
  class: "row",
  style: {"display":"flex","paddingLeft":"15px","paddingRight":"15px","paddingBottom":"15px","max-width":"55vw"}
}
const _hoisted_26 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--normal__black" }, "Descriere: ", -1))
const _hoisted_28 = { class: "text__title--normal" }
const _hoisted_29 = { style: {"width":"25%","display":"flex","flex-direction":"row"} }
const _hoisted_30 = {
  class: "row",
  style: {"display":"flex","flex-direction":"row","justify-content":"center","align-items":"center"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--normal__black" }, "Stare:", -1))
const _hoisted_32 = {
  class: "row",
  style: {"display":"flex","flex-direction":"row","justify-content":"center","align-items":"center"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--normal__black" }, "Progres:", -1))
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { style: {"display":"flex","flex-direction":"row","justify-content":"center","align-items":"center"} }
const _hoisted_36 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_37 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%"} }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--normal" }, "Documente proiect", -1))
const _hoisted_39 = {
  class: "text__label--thin",
  style: {"width":"100%","text-align":"center"}
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%"} }
const _hoisted_42 = {
  key: 1,
  class: "table table-bordered table-condensed table-responsive",
  style: {"width":"100%","max-height":"50vh"}
}
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  class: "desktop-only",
  style: {"max-width":"30vw"}
}
const _hoisted_45 = { class: "mobile-only" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium__black" }, "Etape proiect", -1))
const _hoisted_47 = { class: "q-pa-md" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Editare proiect etapa", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Editare proiect task", -1))
const _hoisted_50 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-weight-bold" }, "Incarca fisier nou", -1))
const _hoisted_52 = {
  class: "text-grey",
  style: {"margin-top":"4px","margin-bottom":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_DialogOpenScan = _resolveComponent("DialogOpenScan")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_EditProiectEtapa = _resolveComponent("EditProiectEtapa")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_EditProiectTask = _resolveComponent("EditProiectTask")!
  const _component_ComboUser = _resolveComponent("ComboUser")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingProiectData)
      ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
          key: 0,
          color: "primary",
          size: "4em",
          class: "absolute-center"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", { src: _ctx.getLinkToQrCode }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", {
                          class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                        }, [
                          _hoisted_11,
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.proiect.denumire), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                        }, [
                          _createElementVNode("span", _hoisted_13, "ID " + _toDisplayString(_ctx.proiect.id_proiect) + " / " + _toDisplayString(_ctx.proiect.track_date), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                        }, [
                          _hoisted_14,
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.proiect.data_start), 1),
                          _hoisted_16,
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.proiect.data_end), 1),
                          _hoisted_18,
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.proiect.durata), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                        }, [
                          _hoisted_20,
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.proiect.denumire_user_created), 1),
                          _hoisted_22,
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.proiect.responsabil), 1)
                        ], 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", {
                            class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                          }, [
                            _hoisted_27,
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.proiect.descriere), 1)
                          ], 2)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", {
                        class: _normalizeClass({ column: _ctx.$q.platform.is.mobile, row: _ctx.$q.platform.is.desktop })
                      }, [
                        _hoisted_31,
                        _createElementVNode("span", {
                          class: _normalizeClass(_ctx.displayStatusColor(_ctx.proiect.stare as string)),
                          style: {"paddingLeft":"10px","font-family":"Nunito Sans","font-size":"1rem","font-weight":"bold"}
                        }, _toDisplayString(_ctx.getDenStatus(_ctx.proiect.stare as string)), 3)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", {
                        class: _normalizeClass({ column: _ctx.$q.platform.is.mobile, row: _ctx.$q.platform.is.desktop })
                      }, [
                        _hoisted_33,
                        _createElementVNode("span", {
                          class: _normalizeClass(_ctx.displayProgres(_ctx.proiect.progres as number)),
                          style: {"paddingLeft":"10px","font-family":"'Nunito Sans'","font-size":"1rem","font-weight":"bold"}
                        }, _toDisplayString(_ctx.proiect.progres) + "%", 3)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", {
                            class: _normalizeClass({ column: _ctx.$q.platform.is.mobile, row: _ctx.$q.platform.is.desktop })
                          }, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", null, [
                                _hoisted_38,
                                _withDirectives(_createElementVNode("div", _hoisted_39, "Nimic atasat", 512), [
                                  [_vShow, _ctx.proiect.scan_documents != null && _ctx.proiect.scan_documents.length==0 && !_ctx.uploadingFileToServer]
                                ])
                              ]),
                              (_ctx.user.auth_for_upload_scan=='y' )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      color: "primary",
                                      icon: "add_box",
                                      "no-caps": "",
                                      disable: _ctx.loadingProiectData,
                                      onClick: _ctx.openFormUploadFile
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_tooltip, {
                                          "transition-show": "rotate",
                                          "transition-hide": "rotate"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Incarca document nou ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["disable", "onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", null, [
                                (_ctx.uploadingFileToServer)
                                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                                      key: 0,
                                      color: "primary",
                                      size: "3em",
                                      thickness: 10
                                    }))
                                  : (_openBlock(), _createElementBlock("table", _hoisted_42, [
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.proiect.scan_documents, (scan_document) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: scan_document.appid
                                          }, [
                                            _createElementVNode("td", null, [
                                              _createElementVNode("span", {
                                                class: "material-icons cursor-pointer",
                                                style: {"color":"red","font-size":"1.3rem"},
                                                onClick: ($event: any) => (_ctx.askIfRemoveScan(scan_document))
                                              }, "delete_forever", 8, _hoisted_43)
                                            ]),
                                            _createElementVNode("td", null, _toDisplayString(scan_document.file_ext), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.humanReadableBytes(scan_document.file_size)), 1),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("div", _hoisted_44, _toDisplayString(scan_document.description), 1),
                                              _createElementVNode("div", _hoisted_45, _toDisplayString(scan_document.description), 1)
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_q_btn, {
                                                round: "",
                                                color: "black",
                                                icon: "cloud_download",
                                                size: "xs"
                                              }),
                                              _createVNode(_component_q_menu, {
                                                fit: "",
                                                "transition-show": "scale",
                                                "transition-hide": "scale"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_DialogOpenScan, {
                                                    appid: scan_document.appid,
                                                    type_scan: "Proiecte"
                                                  }, null, 8, ["appid"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ]))
                              ])
                            ])
                          ], 2)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_q_table, {
              dense: "",
              "rows-per-page-options": [0],
              rows: _ctx.tableDataProiecteEtape,
              columns: _ctx.proiecteEtapeColumns,
              "visible-columns": _ctx.visibleProiecteEtapeColumns,
              "row-key": "appid",
              filter: _ctx.filterEtape,
              loading: _ctx.loadingProiectData,
              pagination: _ctx.myPagination
            }, {
              top: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  flat: "",
                  color: "primary",
                  icon: "add_box",
                  "no-caps": "",
                  size: "lg",
                  disable: _ctx.loadingProiectData,
                  onClick: _ctx.addRowProiecteEtapa
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, {
                      "transition-show": "rotate",
                      "transition-hide": "rotate"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Adauga etape proiect noua ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disable", "onClick"]),
                _hoisted_46,
                _createVNode(_component_q_space),
                _createVNode(_component_q_input, {
                  dense: "",
                  debounce: "300",
                  color: "primary",
                  modelValue: _ctx.filterEtape,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterEtape) = $event))
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, { name: "search" })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              body: _withCtx((props) => [
                _createVNode(_component_q_tr, { props: props }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_td, {
                      key: "id_proiect_etapa",
                      props: props
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.row.id_proiect_etapa) + " ", 1),
                        _createVNode(_component_q_btn, {
                          color: "accent",
                          size: "xs",
                          round: "",
                          dense: "",
                          onClick: ($event: any) => (props.expand = !props.expand),
                          icon: props.expand ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
                        }, null, 8, ["onClick", "icon"])
                      ]),
                      _: 2
                    }, 1032, ["props"]),
                    _createVNode(_component_q_td, {
                      key: "denumire",
                      props: props,
                      sortable: true,
                      style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.row.denumire), 1)
                      ]),
                      _: 2
                    }, 1032, ["props"]),
                    _createVNode(_component_q_td, {
                      key: "task",
                      props: props,
                      sortable: true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.row.task), 1)
                      ]),
                      _: 2
                    }, 1032, ["props"]),
                    _createVNode(_component_q_td, {
                      key: "responsabil",
                      props: props,
                      sortable: true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.row.responsabil), 1)
                      ]),
                      _: 2
                    }, 1032, ["props"]),
                    _createVNode(_component_q_td, {
                      key: "termen",
                      props: props,
                      sortable: true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.displayData(props.row.termen)), 1)
                      ]),
                      _: 2
                    }, 1032, ["props"]),
                    _createVNode(_component_q_td, {
                      key: "progres",
                      props: props,
                      sortable: true,
                      class: _normalizeClass(_ctx.displayProgres(props.row.progres))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.row.progres) + "% ", 1)
                      ]),
                      _: 2
                    }, 1032, ["props", "class"]),
                    _createVNode(_component_q_td, {
                      key: "stare",
                      props: props,
                      sortable: true,
                      class: _normalizeClass(_ctx.displayStatusColor(props.row.stare))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.getDenStatus(props.row.stare)), 1)
                      ]),
                      _: 2
                    }, 1032, ["props", "class"]),
                    _createVNode(_component_q_td, {
                      key: "appid",
                      props: props
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "edit",
                          class: "text-blue cursor-pointer",
                          style: {"font-size":"1.2rem","margin-left":"auto","margin-right":"5px"},
                          onClick: ($event: any) => (_ctx.askIfEditThisProiectEtapa(props.row))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_q_icon, {
                          name: "add",
                          class: "text-blue cursor-pointer",
                          style: {"font-size":"1.3rem","margin-left":"auto"},
                          onClick: ($event: any) => (_ctx.addRowProiecteTask(props.row))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _withDirectives(_createVNode(_component_q_tr, {
                  props: props,
                  class: "q-virtual-scroll--with-prev"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_td, { colspan: "100%" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_q_table, {
                            dense: "",
                            "rows-per-page-options": [0],
                            rows: props.row.proiecteTaskuri?.[0],
                            columns: _ctx.proiecteTaskuriColumns,
                            "visible-columns": _ctx.visibleProiecteTaskuriColumns,
                            "row-key": "appid",
                            filter: _ctx.filterTaskuri,
                            loading: _ctx.loadingProiectData,
                            pagination: _ctx.myPagination
                          }, {
                            body: _withCtx((props) => [
                              _createVNode(_component_q_tr, { props: props }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_td, {
                                    key: "id_proiect_task",
                                    props: props
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(props.row.id_proiect_task), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["props"]),
                                  _createVNode(_component_q_td, {
                                    key: "denumire",
                                    props: props,
                                    sortable: true,
                                    style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(props.row.denumire), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["props"]),
                                  _createVNode(_component_q_td, {
                                    key: "responsabil",
                                    props: props,
                                    sortable: true
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(props.row.responsabil), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["props"]),
                                  _createVNode(_component_q_td, {
                                    key: "termen",
                                    props: props,
                                    sortable: true
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.displayData(props.row.termen)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["props"]),
                                  _createVNode(_component_q_td, {
                                    key: "stare",
                                    props: props,
                                    sortable: true,
                                    class: _normalizeClass(_ctx.displayStatusColor(props.row.stare))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getDenStatus(props.row.stare)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["props", "class"]),
                                  _createVNode(_component_q_td, {
                                    key: "progres",
                                    props: props,
                                    sortable: true,
                                    class: _normalizeClass(_ctx.displayProgres(props.row.progres))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(props.row.progres) + "% ", 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["props", "class"]),
                                  _createVNode(_component_q_td, {
                                    key: "appid",
                                    props: props
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_icon, {
                                        name: "edit",
                                        class: "text-blue cursor-pointer",
                                        style: {"font-size":"1.0rem","margin-left":"auto"},
                                        onClick: ($event: any) => (_ctx.askIfEditThisProiectTask(props.row))
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1032, ["props"])
                                ]),
                                _: 2
                              }, 1032, ["props"])
                            ]),
                            _: 2
                          }, 1032, ["rows", "columns", "visible-columns", "filter", "loading", "pagination"])
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["props"]), [
                  [_vShow, props.expand]
                ])
              ]),
              _: 1
            }, 8, ["rows", "columns", "visible-columns", "filter", "loading", "pagination"]),
            _createVNode(_component_q_dialog, {
              modelValue: _ctx.visibleDialogEditProiectEtapa,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visibleDialogEditProiectEtapa) = $event)),
              persistent: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card, { style: {"min-width":"60vw","max-width":"80vw"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_bar, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, { name: "add_box" }),
                        _hoisted_48,
                        _createVNode(_component_q_space),
                        _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                          dense: "",
                          flat: "",
                          icon: "close",
                          onClick: _ctx.refreshDataTableProiecteEtape
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Close")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onClick"])), [
                          [_directive_close_popup]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_card_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_EditProiectEtapa, {
                          foncancel: _ctx.renuntEditareProiecteEtapa,
                          fonsave: _ctx.refreshDataTableProiecteEtape,
                          appid: _ctx.appidProiectEtapa,
                          currentRowView: _ctx.proiect
                        }, null, 8, ["foncancel", "fonsave", "appid", "currentRowView"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_dialog, {
              modelValue: _ctx.visibleDialogEditProiectTask,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visibleDialogEditProiectTask) = $event)),
              persistent: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card, { style: {"min-width":"60vw","max-width":"80vw"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_bar, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, { name: "add_box" }),
                        _hoisted_49,
                        _createVNode(_component_q_space),
                        _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                          dense: "",
                          flat: "",
                          icon: "close",
                          onClick: _ctx.refreshDataTableProiecteTaskuri
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Close")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onClick"])), [
                          [_directive_close_popup]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_card_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_EditProiectTask, {
                          foncancel: _ctx.renuntEditareProiecteTask,
                          fonsave: _ctx.refreshDataTableProiecteTaskuri,
                          appid: _ctx.appidProiectTask,
                          currentRowViewProiect: _ctx.proiect,
                          currentRowViewProiectEtapa: _ctx.proiectEtapa
                        }, null, 8, ["foncancel", "fonsave", "appid", "currentRowViewProiect", "currentRowViewProiectEtapa"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.viewDialogSelectPersoana,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.viewDialogSelectPersoana) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"min-width":"70vw"},
          class: _normalizeClass({ 'partial80_height': _ctx.$q.platform.is.mobile, 'partial60_height': _ctx.$q.platform.is.desktop })
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("span", {
                class: "material-icons cursor-pointer",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.viewDialogSelectPersoana=false)),
                style: {"color":"#747474","font-weight":"bolder","font-size":"1.5em"}
              }, "close")
            ]),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_ComboUser, {
                  selectHandler: _ctx.selectPersoana,
                  title: "Selectati persoana responsabil"
                }, null, 8, ["selectHandler"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogUploadFile,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialogUploadFile) = $event)),
      position: "top"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"350px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_linear_progress, {
              value: 0.6,
              color: "pink"
            }),
            _createVNode(_component_q_card_section, { class: "column no-wrap" }, {
              default: _withCtx(() => [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_q_input, {
                    counter: "",
                    outlined: "",
                    modelValue: _ctx.uploadScanTitle,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.uploadScanTitle) = $event)),
                    label: "Titlu document (minim 4 caractere)",
                    dense: "",
                    maxlength: "200"
                  }, null, 8, ["modelValue"])
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "file",
                  name: "fileToUpload",
                  id: "fileToUpload",
                  ref: "myFileToUpload",
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.prepareForUpload($event))),
                  style: {"margin-bottom":"10px"}
                }, null, 544), [
                  [_vShow, _ctx.uploadScanTitle.length>3]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  disable: !(_ctx.uploadScanTitle.length>3),
                  icon: "cloud_upload",
                  color: "white",
                  "text-color": "black",
                  label: "Salveaza pe server",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.uploadFile())),
                  loading: _ctx.uploadingFileToServer,
                  style: {"margin-bottom":"5px"}
                }, null, 8, ["disable", "loading"]), [
                  [_vShow, _ctx.checkIfFileIsSelected]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}